<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_order_deliver_product_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="发货单号">
							<c-input name="deliver_code"></c-input>
						</m-search-item>
						<m-search-item label="销售订单">
							<c-input name="order_number"></c-input>
						</m-search-item>
						<m-search-item label="客户">
							<c-select name="customer_ids" async multiple @search="searchCustomer"></c-select>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="支持产品编号/名称/规格"></c-input>
						</m-search-item>
						<m-search-item label="发货单状态">
							<c-select name="states" :options="approvalStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_order_deliver_product_export')" v-lock="lock('b_order_deliver_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_order_deliver_product_export')" v-lock="lock('b_order_deliver_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_order_deliver_product_export')" v-lock="lock('b_order_deliver_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_order_deliver_product_export')" v-lock="lock('b_order_deliver_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_order_deliver_product_print')" v-lock="lock('b_order_deliver_product_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<!--发货单号-->
				<template #deliver_code="{data}">
					<c-link v-if="auth('b_order_deliver_query')" @click="globalDialog('orderDeliverDetail', {props: {id: data.order_deliver_id}})">{{data.deliver_code}}</c-link>
                    <span v-else>{{data.deliver_code}}</span>
				</template>

				<!--关联订单号-->
				<template #order_number="{data}">
					<c-link v-if="data.order_number && auth('b_order_query')" @click="globalDialog('orderDetail', {props: {id: data.order_id}})">{{data.order_number}}</c-link>
                    <span v-else-if="data.order_number">{{data.order_number}}</span>
					<span v-else>-</span>
				</template>

				<!--发货单状态-->
				<template #state="{data}">
					<c-state dict="approvalStateDic" tag :value="data.state"></c-state>
				</template>

				<!--销售单价-->
				<template #product_price="{data}">
					<span v-if="data.product_price">￥{{data.product_price}}</span>
					<span v-else>-</span>
				</template>

				<!--发货金额-->
				<template #product_money="{data}">
					<span v-if="data.product_money">￥{{data.product_money}}</span>
					<span v-else>-</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="60"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_order_deliver_product_print')" v-lock="lock('b_order_deliver_product_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
				workType: 33
			}
		},

		computed: {
			...mapState(['approvalStateDic'])
		},

		methods: {
			/*******搜索【客户】下拉框信息*****************/
			searchCustomer(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'CUSTOMER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>
